import React, { memo } from "react";

import NavArrow from "./NavArrow";

interface NavArrowsProps {
    navScrollArrows: {
        isHovered: boolean;
        showLeftArrow: boolean;
        showRightArrow: boolean;
    };
    showTournamentCup: boolean;
    scrollNavLeft: () => void;
    scrollNavRight: () => void;
}

const NavArrows: React.FC<NavArrowsProps> = ({
    navScrollArrows,
    showTournamentCup,
    scrollNavLeft,
    scrollNavRight
}) => {
    return (
        <>
            {navScrollArrows.isHovered && (
                <>
                    {/* Left Arrow */}
                    {navScrollArrows.showLeftArrow && (
                        <NavArrow
                            navScrollArrows={navScrollArrows}
                            direction="left"
                            showTournamentCup={showTournamentCup}
                            onClick={scrollNavLeft}
                        />
                    )}

                    {/* Right Arrow */}
                    {navScrollArrows.showRightArrow && (
                        <NavArrow
                            navScrollArrows={navScrollArrows}
                            direction="right"
                            showTournamentCup={showTournamentCup}
                            onClick={scrollNavRight}
                        />
                    )}
                </>
            )
            }
        </>
    );
}

export default memo(NavArrows);